module.exports = __webpack_public_path__ + "img/advantage_icon_latency.1a453873.svg";